import { render, staticRenderFns } from "./DefaultDeadlineMechanismForm.vue?vue&type=template&id=13808d46&scoped=true"
import script from "./DefaultDeadlineMechanismForm.vue?vue&type=script&lang=js"
export * from "./DefaultDeadlineMechanismForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13808d46",
  null
  
)

export default component.exports